<template>
  <b-tab title="Más información">
    <div class="container-fluid">
      <b-row>
        <b-col lg="6">
          <h5>Cliente</h5>
          <b-row>
            <b-col md="4">
              <label>Razón social </label>
            </b-col>
            <b-col> {{ cliente.razonSocial || cliente.nombre }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>País </label>
            </b-col>
            <b-col> {{ pais.nombre }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Teléfono </label>
            </b-col>
            <b-col> {{ cliente.telefono }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Email </label>
            </b-col>
            <b-col> {{ cliente.email }} </b-col>
          </b-row>
          <h5>Contacto principal</h5>
          <b-row>
            <b-col md="4">
              <label>Contacto </label>
            </b-col>
            <b-col> {{ clienteContacto.contacto }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Cargo del Contacto </label>
            </b-col>
            <b-col> {{ clienteContacto.cargoContacto }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Teléfono </label>
            </b-col>
            <b-col> {{ clienteContacto.telefono }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4">
              <label>Email </label>
            </b-col>
            <b-col> {{ clienteContacto.email }} </b-col>
          </b-row>
        </b-col>

        <b-col lg="6">
          <h5>Oferta</h5>
          <b-row class="mb-2">
            <b-col md="4"> <label> Tipo de proyecto </label> </b-col>
            <b-col> {{ nombreTipoProyecto }} </b-col>
          </b-row>
          <campo-pipedrive />
          <br />
          <b-row>
            <b-col md="4"> <label> Valorada </label> </b-col>
            <b-col> {{ valorada }} </b-col>
          </b-row>
          <b-row>
            <b-col md="4"> <label> Motivo de cierre </label> </b-col>
            <b-col> {{ motivoCierre.nombre || "No especificado" }}</b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </b-tab>
</template>
<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import { nombreTipoProyecto } from "@/enums/TipoProyecto";
import CampoPipedrive from "./CamposOferta/CampoPipedrive";

export default {
  components: {
    CampoPipedrive,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(useOfertaFormStore, [
      "oferta",
      "cliente",
      "clienteContacto",
      "pais",
      "ofertaPipedrive",
      "motivoCierre",
    ]),
    valorada() {
      if (this.oferta.valorada) {
        const options = {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        };
        const fecha = new Date(this.oferta.valoradaEl).toLocaleDateString("es", options);
        return `Si, el ${fecha}`;
      }
      return "No";
    },
    nombreTipoProyecto() {
      return nombreTipoProyecto(this.oferta.tipoProyecto);
    },
  },
};
</script>
